<template>
  <in-view
    :threshold="0"
    :threshold-type="'px'"
    class="slide-into-view-transition col"
    :class="!displayImageState ? 'navigation-block__link-item-wrapper' : ''"
  >
    <div class="navigation-block__item">
      <template v-if="displayImageState">
        <div
          class="navigation-block__image-wrapper"
          @click="simulateClickOnLink"
        >
          <epi-property
            id="Image"
            text="Bild"
          />
          <epi-picture
            :image="image"
            :sizes="dimensions"
            :use-picture="false"
            :auto-aspect-ratio="false"
          />
        </div>
      </template>
      <link-wrapper
        ref="linkWrapperRef"
        :edit-block="contentId"
        :classes="'navigation-block__content ' + bordersOnImageState"
        :url="url"
        :target="target"
        :title="buttonLabel"
        :tracking="{
          event: 'navigationBlockSelect'
        }"
      />
    </div>
    <epi-property
      id="ButtonLabel"
      text="Knapptext"
    />
    <epi-property
      id="Url"
      text="Knapplänk"
    />
  </in-view>
</template>
<script>
import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'

export default {
  name: "NavigationBlock",
  components: {
    linkWrapper,
  },
  props: {
    image: {
      type: Object,
      default: null
    },
    buttonLabel: {
      type: String,
      default: "Läs mer"
    },
    displayImageState: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ""
    },
    contentId: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          height: 160,
          width: 720
        },
        medium: {
          height: 160,
          width: 470
        },
        large: {
          height: 160,
          width: 400
        }
      }
    }
  },
  computed: {
     bordersOnImageState () {
      return this.displayImageState ? 'has-border-with-image' : ""
    }
  },
  methods: {
    simulateClickOnLink () {
      // To simulate click in link-wrapper component we first need to traverse down through link-wrapper
      this.$refs.linkWrapperRef.$refs.linkWrapperATag.click()
    },
  }
 }
</script>

<style lang="scss">
.navigation-block {
  $this: &;

  &__link-item-wrapper.col {
    @include media-breakpoint-down(sm) {
      padding-bottom: 0.5rem;
    }
  }

  &__item {
    text-decoration: none;
    display: block;
    height: 100%;

    .epi-background-container,
    .empty-image-placeholder {
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
      height: 160px;
    }
  }

  &__image-wrapper {
    cursor: pointer;
  }

  &__content {
    background-color: $color-white;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color-secondary-cta-text;
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.06);
    fill: $color-secondary-cta-text;

    &:not(.has-border-with-image) {
      height: 100%;
    }

    @include addTransition();
    @include font(text, 3, "bold");

    @include media-breakpoint-up(md) {
      padding: 1rem 1.5rem;
    }

    &.has-border-with-image {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
  }
}
</style>



